"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { SPOTLIGHT } from "@/lib/site";

// SPOTLIGHT (lib/site.js) always goes first: whatever Lulu is pushing right now.
const NAV = [
  ...(SPOTLIGHT ? [{ href: SPOTLIGHT.href, label: SPOTLIGHT.label }] : []),
  { href: "/menus/", label: "Menus" },
  { href: "/events-and-show-menu/", label: "Pre-Show Menu" },
  { href: "/bottomless-brunch/", label: "Bottomless Brunch" },
  { href: "/events-hire/", label: "Events & Hire" },
  { href: "/guides/", label: "Guides" },
  { href: "/contact/", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  // Lock page scroll while the mobile menu is open.
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-inner">
        <Link href="/" className="logo" aria-label="Lulu Wild home">
          <img src="/media/2021/07/Artboard-18@2x.png" alt="Lulu Wild" width="255" height="326" style={{ height: 64, width: "auto" }} />
        </Link>
        <nav className={`main-nav ${open ? "open" : ""}`} aria-label="Main">
          {NAV.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              aria-current={pathname === item.href || (item.href !== "/" && pathname.startsWith(item.href)) ? "page" : undefined}
            >
              {item.label}
            </Link>
          ))}
          <Link href="/reservations/" className="nav-book">
            Book a Table
          </Link>
        </nav>
        <Link href="/reservations/" className="header-book">Book</Link>
        <button
          className={`nav-toggle ${open ? "open" : ""}`}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
